import styled from 'styled-components';

export const ReceiptTable = styled.table`
  width: 100%;
`;
